<div class="flex justify-center my-4 w-full">
  <lib-my-account
    [labels]="'lib.myAccount' | translate"
    [dateLocale]="dateLocale"
    class="w-full"
    [bank]="bank"
    [userInfoList]="userInfoList"
    [languesOptions]="languesOptions"
    [showLanguagesSection]="false"
    [showPwdChangedPopup]="showPwdChangedPopup"
    (currentPasswordInput)="verifyCurrentPassword($event)"
    (changeUserInfoEmitter)="updateUserInformation($event)"
    (changeUserPasswordEmitter)="updateUserPassword($event)"
    (afterPwdChangedEvent)="goToLoginModal()"
    [currentUserPasswordState]="currentUserPasswordState"
  ></lib-my-account>
</div>

<!--Snackbar-->
@if (showSnackbar) {
  <lib-snackbar
    [labels]="'lib.snackbar' | translate"
    [bank]="bank"
    [theme]="snackbarParams.theme"
    [title]="snackbarParams.message"
    [showIconLeft]="true"
    [showIconRight]="false"
    [position]="'bottom'"
    >
  </lib-snackbar>
}
